import { render, staticRenderFns } from "./BookSummary.vue?vue&type=template&id=6c372f7c&scoped=true&"
import script from "./BookSummary.vue?vue&type=script&lang=js&"
export * from "./BookSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookSummary.vue?vue&type=style&index=0&id=6c372f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c372f7c",
  null
  
)

export default component.exports